<div class="service-page">
  <header>
    <h1>
      {{ 'service-page.peb.title' | translate }}
    </h1>
    <picture class="service-page-banner"> <img src="../../../assets/images/service-page-peb.png" alt=""/></picture>
  </header>
  <div class="content">
    <h2>
      {{ 'service-page.peb.intro' | translate }}
    </h2>
    <div [innerHTML]="'service-page.peb.content' | translate"></div>

    <a class="btn btn-big btn-accent" (click)="toOrdering()">
      {{ 'service-page.peb.action' | translate }}
    </a>
  </div>
</div>
